/// <amd-module name="Build/Run/Components/WorkItemsLink" />
import * as React from "react";

import { ChangesData } from "Build/Client/Contracts/DataProvider";
import { IBuildLinkingService } from "Build/Client/Linking";
import * as Resources from "Build/Run/Resources";
import { RepositoryTypes } from "Build/SourceProviders/Common";

import { ITfsPageService } from "Tfs/Platform/Page";

import { IReadonlyObservableValue } from "VSS/Core/Observable";
import { format } from "VSS/Core/Util/String";
import { FPSLink } from "VSS/Features/PlatformUI/FPSLink";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";

import { Icon } from "VSSUI/Icon";
import { Observer } from "VSSUI/Observer";

const baseWiql = "SELECT System.Id, System.WorkItemType, System.Title, System.State, System.AssignedTo, System.CreatedDate, Microsoft.VSTS.Common.Priority, System.AreaPath FROM WorkItems where ";

interface IWorkItemsLinkProps {
    associatedChangesData: IReadonlyObservableValue<ChangesData>;
    sourceType: string;
    linkDescribedBy?: string;
    showIcon?: boolean; // default true
}

export class WorkItemsLink extends VssComponent<IWorkItemsLinkProps> {
    private _projectId: string = "";
    private _linkService: IBuildLinkingService;

    constructor(props: IWorkItemsLinkProps, context: IVssComponentContext) {
        super(props, context);

        const tfsPageService = context.pageContext.getService<ITfsPageService>("ITfsPageService");
        const tfsPageData = tfsPageService.getData();
        if (tfsPageData && tfsPageData.project) {
            this._projectId = tfsPageData.project.id;
        }

        this._linkService = context.pageContext.getService<IBuildLinkingService>("IBuildLinkingService");
    }

    public render() {
        const sourceType = this.props.sourceType.toLocaleLowerCase();
        const addLink = sourceType === RepositoryTypes.TfsGit.toLocaleLowerCase() || sourceType === RepositoryTypes.TfsVersionControl.toLocaleLowerCase();

        return <Observer associatedChanges={this.props.associatedChangesData}>
        {
            (observerProps: {associatedChanges: ChangesData}) => {
                const items = observerProps.associatedChanges.workItems;
                const url = addLink ? this._linkService.getWorkItemQueryUrl(this._createWiql(items), this._projectId) : "";
        
                if (items && items.length > 0) {
                    const text = format(Resources.WorkItemsFormat, items.length.toString());
                    let className = "text-ellipsis flex-row flex-baseline";

                     if (addLink) {
                        return (
                            <FPSLink ariaDescribedBy={this.props.linkDescribedBy} href={url} className={className} subtle={true}>
                                <span className="text-ellipsis">
                                    {this.props.showIcon !== false && <Icon iconName="WorkItem" className="pipelines-icon-right-margin" /> }
                                    {text}
                                </span>
                            </FPSLink>
                        );
                    }
                    className += " pipelines-icon-left-margin";
                    return (
                        <div className={className}>
                            <span className="text-ellipsis">
                                {this.props.showIcon !== false && <Icon iconName="WorkItem" className="pipelines-icon-right-margin" /> }
                                {text}
                            </span>
                        </div>
                    );
                }
                else {
                    return (
                        <span className="text-ellipsis secondary-text summary-line-non-link">
                            {this.props.showIcon !== false && <Icon iconName="WorkItem" className="pipelines-icon-right-margin" /> }
                            {this.props.showIcon !== false && format(Resources.WorkItemsFormat, "0")}
                            {this.props.showIcon === false && <span className="secondary-text">{Resources.None}</span>}
                        </span>
                    );
                }
            }
        }
        </Observer>;
    }

    private _createWiql = (workItems: any[]): string => { 
        let whereClause = "";

        (workItems || []).forEach((workItem) => {
            if (whereClause !== "")
            {
                whereClause += "or "
            }
            whereClause += "System.Id = " + workItem.id + " ";
        });

        return baseWiql + whereClause;
    }
}